import { Component, Input } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-crop-health-note-delete-confirm',
  imports: [SharedModule],
  templateUrl: './crop-health-note-delete-confirm.component.html',
  styleUrl: './crop-health-note-delete-confirm.component.less',
})
export class CropHealthNoteDeleteConfirmComponent {
  @Input() description: string;
  @Input() confirmBtnLabel: string;
  @Input() cancelBtnLabel: string;
  
  constructor(private dynamicDialogRef: DynamicDialogRef) {}

  close(submit = false) {
    this.dynamicDialogRef.close(submit);
  }
}
